<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Animaux</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter un animal
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableAnimal"
          identifier="B122TableAnimal"
          init-b122-table-url="/animal/initB122Table"
          get-b122-table-results-url="/animal/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
        >
          <template #cell(actions)="row">
            <div class="actions-container text-right">
              <button class="btn-icon-edit mr-1" @click="clickOnEditBtn(row)">
                <pencil-icon size="18"/>
              </button>
              <button class="btn-icon-primary-dark" @click="clickOnDeleteBtn(row)">
                <trash-icon size="18"/>
              </button>
              <button class="btn-icon-primary-dark-outlined"
                      :style="{ opacity: row.item.isDead ? 0.5 : 1 }"
                      @click="clickOnDeadAnimalBtn(row)">
                <HeartOffIcon/>
              </button>
            </div>
          </template>
        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <animal-delete-modal :selectedAnimal="ui.selectedAnimal" @didDeleteAnimal="didDeleteAnimal()"></animal-delete-modal>

    <hospitalization-confirm-animal-death-modal v-if="ui.selectedAnimal" :animal="ui.selectedAnimal" :is-dead="!ui.isDeadAnimal" @onAnimalDeathConfirmed="didConfirmDeathAnimal"></hospitalization-confirm-animal-death-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import AnimalDeleteModal from "./AnimalDeleteModal";
import HeartOffIcon from "../../assets/icons/HeartOffIcon.vue";
import HospitalizationConfirmAnimalDeathModal from "../hospitalization/HospitalizationConfirmAnimalDeathModal.vue";

export default {

  name: 'AnimalIndex',

  components: {
    HospitalizationConfirmAnimalDeathModal,
    HeartOffIcon,
    B122Table,
    AnimalDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Nom",
          key: "name",
          sortable: true
        },
        {
          label: "Espèce",
          key: "species.name",
          sortable: true
        },
        {
          label: "Famille",
          key: "species.family",
          sortable: true
        },
        {
          label: "Hospitalisé",
          key: "isHospitalized",
          sortable: false,
          formatter: function (value, key, item) {
            if (value) {
              return "Oui"
            }
            return "Non"
          }
        },
        {
          label: "Propriétaire",
          key: "user.name",
          sortKey: "user.lastName",
          sortable: true
        },
        {
          label: "Date de naissance",
          key: "dateOfBirth",
          sortable: true,
          formatter: function (value, key, item) {
            if(value != null) {
              var date = new Date(value)
              return date.toLocaleString('fr-FR',  { year: 'numeric', month: '2-digit', day: '2-digit' })
            }
            return "-"
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedAnimal: null,
        isDeadAnimal: false
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'AnimalCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'AnimalShow',
        params: {
          animalId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'AnimalEdit',
        params: {
          animalId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedAnimal = row.item
      this.$bvModal.show('animal-delete-modal')
    },

    didDeleteAnimal() {
      this.ui.selectedAnimal = null;
      this.$refs.B122TableAnimal.refreshTable()
    },

    clickOnDeadAnimalBtn(row) {
      this.ui.selectedAnimal = row.item
      this.ui.isDeadAnimal = row.item.isDead
      this.$nextTick(() => {
        this.$bvModal.show('hospitalization-confirm-animal-death-modal')
      })
    },

    didConfirmDeathAnimal() {
      this.ui.selectedAnimal = null;
      this.ui.isDeadAnimal = false;
      this.$refs.B122TableAnimal.refreshTable()
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/animal/AnimalIndex.vue